function Logo({width}) {
  return (
    <img src="/static/images/logo/logo-namie-smamobi.png" width={width}/>
  );
}

export default Logo;
